<template>
  <v-row>
    <v-col>
      <v-card>
        <v-row class="pa-4">
          <v-col cols="12">
            <h2 class="title">Chart Options</h2>
            <v-divider class="pb-4"/>
          </v-col>
          <v-col cols="12" sm="6">
            <v-row>
              <v-col cols="6">
                <v-radio-group v-model="measurement" :mandatory="true" @change="setGraphDataSettings()">
                  <v-radio label="Temperature" value="temperature"></v-radio>
                  <v-radio label="Precipitation" value="precipitation"></v-radio>
                </v-radio-group>
              </v-col>
              <v-col cols="6">
                <v-radio-group v-model="graphType" :mandatory="true" @change="setGraphDataSettings()">
                  <v-radio label="Line" value="line"></v-radio>
                  <v-radio label="Bar" value="bar"></v-radio>
                </v-radio-group>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" md="6">
            <v-row>
              <v-col cols="12" sm="6">
                <v-btn block color="primary" class="my-2" @click="setGroupby('region')">Toggle Region Grouping</v-btn>
                <v-btn block color="primary" class="" @click="setGroupby('area')">Toggle Area Grouping</v-btn>
              </v-col>
              <v-col cols="12" sm="6">
                <v-btn block color="primary" class="my-2" @click="toggleYearsViz()">Toggle Years Comparison</v-btn>
                <v-btn block color="primary" class="" @click="toggleMinMaxData()">Toggle Min/Max Series</v-btn>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card>
    </v-col>
  </v-row>
</template>
<script>
export default {
  data() { return {
    measurement: "temperature",
    graphType: "line",
    yearsViz: false,
    groupBy: null
  }},
  methods:{
    setGroupby(value){
      this.$store.commit('TOGGLE_GROUP_BY', {
        groupBy: value
      })
    },
    toggleYearsViz(){
      this.$store.commit('TOGGLE_YEAR_VIZ')
    },
    setGraphDataSettings(){
      this.$store.commit('SET_GRAPH_DATA_SETTINGS', {
        measurement: this.measurement,
        graphType: this.graphType,
        yearsViz: this.yearsViz,
        groupBy: this.groupBy
      })
    },
    toggleMinMaxData(){
      this.$store.commit('TOGGLE_MIN_MAX')
    },
  }
}
</script>

